/*
 * Timeline reveal.
 * The animation classes are added by script, so if this never runs the
 * section renders fully visible rather than blank — the failure mode that
 * hid the "New arrivals" heading earlier.
 */
(function () {
  function setup(root) {
    if (root.dataset.nvTlReady) return;
    root.dataset.nvTlReady = '1';

    var items = root.querySelectorAll('.nv-tl__item');
    if (!items.length) return;

    // Opt in only when we can actually observe.
    if (!('IntersectionObserver' in window)) return;
    root.classList.add('nv-tl--anim');

    var rule = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          root.classList.add('is-visible');
          rule.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    rule.observe(root);

    function revealAll() {
      Array.prototype.forEach.call(items, function (el, i) {
        // Stagger left to right, so the row reads 1985 -> today.
        var delay = Math.min(i * 160, 640);
        el.style.transitionDelay = delay + 'ms';
        var dot = el.querySelector('.nv-tl__dot');
        // The marker lands just after its milestone.
        if (dot) dot.style.transitionDelay = delay + 220 + 'ms';
        el.classList.add('is-in');
      });
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        revealAll();
        io.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });

    io.observe(root);
  }

  function init() {
    document.querySelectorAll('.nv-tl').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);
})();
